


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class Overlay extends Vue {
  @Prop({ default: false }) public dialog!: boolean;

  @Prop({ default: '400px' }) public width!: string;

  @Prop({ default: 'inherit' }) public maxWidth!: string;

  @Prop({ default: 'inherit' }) public maxHeight!: string;

  @Prop({ default: '600px' }) public contentHeight!: string;
}
